import { camelCase, pascalCase } from "../helpers/caseHelpers";
import { strContains } from "../helpers/tsHelper";
import { IModelMemberInfo } from "../ModelInfos/IModelInfo";
import { IExportProfile } from "./IExportProfile";
import { IExportProfileService } from "./IExportProfileService";

export function csharpTypeConverter(member: IModelMemberInfo): void {
    const type = member.type;
    const newType = { ...type };

    if (strContains(type.name, 'uniqueidentifier')) {
        newType.name = "Guid";
    }

    if (strContains(type.name, 'string')) {
        newType.name = "string";
    }
    if (strContains(type.name, 'text')) {
        newType.name = "string";
    }
    if (strContains(type.name, 'char')) {
        newType.name = "string";
    }
    if (strContains(type.name, 'number')) {
        newType.name = "double";
    }
    if (strContains(type.name, 'date') || strContains(type.name, 'datetime')) {
        newType.name = "DateTime";
    } else if (strContains(type.name, 'time')) {
        newType.name = "TimeSpan";
    }
    if (strContains(type.name, 'tinyint')) {
        newType.name = "bool";
    } else if (strContains(type.name, 'int')) {
        newType.name = "int";
    }

    if (strContains(type.name, 'bit')) {
        newType.name = "bool";
    }

    if (strContains(type.name, 'bool')) {
        newType.name = "bool";
    }

    if (strContains(type.name, 'decimal')) {
        newType.name = "decimal";
    }

    if (strContains(type.name, 'long')) {
        newType.name = "long";
    }

    if (strContains(type.name, 'binary') || strContains(type.name, 'byte')) {
        newType.name = "byte[]";
    }

    if (member.nullable) {
        if (["double", "char", "int", "bool", "long", "guid", "decimal", "byte", "datetime"].includes(newType.name.toLowerCase())) {
            newType.name = newType.name + "?";
        }
    }
    member.type = newType;
}

export function typescriptTypeConverter(member: IModelMemberInfo): void {
    const type = member.type;
    const newType = { ...type };

    if (strContains(type.name, 'string')) {
        newType.name = "string";
    }
    if (strContains(type.name, 'char')) {
        newType.name = "string";
    }
    if (strContains(type.name, 'text')) {
        newType.name = "string";
    }
    if (strContains(type.name, 'number') || strContains(type.name, 'double') || strContains(type.name, 'long') || strContains(type.name, 'int') || strContains(type.name, 'decimal')) {
        newType.name = "number";
    }
    if (strContains(type.name, 'date') || strContains(type.name, 'time')) {
        newType.name = "Date";
    }

    if (strContains(type.name, 'bool') || strContains(type.name, 'tinyint')) {
        newType.name = "boolean";
    }

    if (strContains(type.name, 'guid')) {
        newType.name = "string";
    }
    member.type = newType;
}


export class ExportProfileService implements IExportProfileService {
    getExportProfiles(): IExportProfile[] {
        return [
            { id: "csharp", name: "C#", modelNameCaseConverter: pascalCase, memberNameCaseConverter: pascalCase, viewModelPrefix: "Vm", dataModelPrefix: "Dm", typeConverter: csharpTypeConverter },
            { id: "typescript", name: "Typescript", modelNameCaseConverter: pascalCase, memberNameCaseConverter: camelCase, typeConverter: typescriptTypeConverter },
        ];
    }
}